// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"95df8c48","316":"47c2aca8","397":"efa75442","455":"1ee00c03","477":"fd3fefd5","484":"14cb0921","488":"201b1ad0","904":"71b45f04","933":"31ce9127"}[chunkId] + ".chunk.js";
};